<template>
  <v-dialog :value="value" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">Broadcast History</span>
        <v-spacer />
        <v-btn small icon flat @click="handleClose">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- <v-card-detail> -->
      <v-data-table
        :headers="headers"
        :items="broadcastHistory"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="total"
      >
        <template #items="props">
          <td>{{ props.item.aira_id }}</td>
          <td>{{ props.item.first_name }}</td>
          <td>{{ props.item.last_name }}</td>
          <td>{{ props.item.phoneno }}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.app }}</td>
        </template>
      </v-data-table>
      <!-- </v-card-detail> -->
    </v-card>
  </v-dialog>
</template>

<script>
import airaApi from '@/api/aira'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
export default {
  name: 'DialogBroadcastHistoryVue',
  props: ['value', 'broadcast', 'type'],
  data() {
    return {
      offset: 0,
      broadcastHistory: [],
      pagination: {
        rowsPerPage: 5
      },
      total: 0,
      loading: false,
      headers: [
        { text: 'Aira id', value: 'aira_id', sortable: false },
        { text: 'ชื่อ', value: 'first_name', sortable: false },
        { text: 'นามสกุล', value: 'last_name', sortable: false },
        { text: 'เบอร์โทรศัพท์', value: 'phoneno', sortable: false },
        { text: 'อีเมล', value: 'email', sortable: false },
        { text: 'ช่องทาง', value: 'app', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.offset = 0
        this.broadcastHistory = []
        this.total = 0
        this.handleLoadBroadcastHistory()
      }
    },
    pagination: {
      async handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          this.offset = (page - 1) * rowsPerPage
          const result = await this.handleGetBroadcastHistory({
            limit: this.pagination.rowsPerPage == -1 ? undefined : this.pagination.rowsPerPage,
            offset: this.offset
          })
          if (result) {
            const { broadcastHistory, total } = result
            this.broadcastHistory = broadcastHistory
            this.total = total
          }
          this.loading = false
        }
      },
      deep: true
    }
  },
  methods: {
    async handleLoadBroadcastHistory() {
      this.loading = true
      const result = await this.handleGetBroadcastHistory({
        limit: this.pagination.rowsPerPage == -1 ? undefined : this.pagination.rowsPerPage,
        offset: this.offset
      })
      if (result) {
        const { broadcastHistory, total } = result
        this.broadcastHistory = broadcastHistory
        this.total = total
      }
      this.loading = false
    },
    async handleGetBroadcastHistory({ limit, offset }) {
      try {
        const response = await airaApi.getBroadcastLog({
          id: this.broadcast.id,
          params: {
            limit,
            offset,
            page_id: this.selectedBot.pageid,
            status: this.type == 'reach' ? true : false
          }
        })
        if (response && response.status == 200 && response.data.data) {
          // get broadcast history
          return {
            broadcastHistory: response.data.data,
            total:
              typeof response.data.total == 'string'
                ? parseInt(response.data.total)
                : response.data.total
          }
        } else {
          return {
            broadcastHistory: [],
            total: 0
          }
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    handleClose() {
      this.$emit('onClose', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/DialogBroadcastHistory.vue